import PatientOverviewMedicationStatus from 'dashboard/templates/views/Patient/Medication/PatientOverviewMedicationStatus';

export default {
  path: 'status',
  name: 'PatientRecordMedicationStatus',
  component: PatientOverviewMedicationStatus,
  meta: {
    // title: 'Patient Record - Medication - Status',
    // title: t => `${t('patient.patientRecord')} - ${t('screens.medicationAdherenceScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    // title: 'Medication - Status',
    title: t => `${t('screens.medicationAdherenceScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
